import { render, staticRenderFns } from "./ProjectOverdueNotification.vue?vue&type=template&id=54fec766&scoped=true&"
import script from "./ProjectOverdueNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectOverdueNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fec766",
  null
  
)

export default component.exports